import { render, staticRenderFns } from "./AsideNav.vue?vue&type=template&id=c6c5474c&scoped=true&"
import script from "./AsideNav.vue?vue&type=script&lang=js&"
export * from "./AsideNav.vue?vue&type=script&lang=js&"
import style0 from "./AsideNav.vue?vue&type=style&index=0&id=c6c5474c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c5474c",
  null
  
)

export default component.exports